
<div class="black-inputs">
  <el-row>
    <el-col :span="22" :offset="2">
      <el-form ref="dataClientForm" :rules="rulesFormPart1" :model="dataClient.data" label-width="0px">
        <el-row>
          <el-col :span="6">Message d'annulation :</el-col>
          <el-col :span="18">
            <el-form-item prop="resaMessage">
              <el-input v-model="dataClient.data.resaMessage" :autosize="{ minRows: 3 }" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-col>
  </el-row>
  <el-row>
    <el-col :span="10" :offset="1">
      <el-button class="dark" type="primary" @click="closeDialog()">Annuler</el-button>
    </el-col>
    <el-col :span="10" :offset="1">
      <el-button type="primary" @click="sendAnnulation()">Envoyer</el-button>
    </el-col>
  </el-row>
</div>
